module.exports = __webpack_public_path__ + "static/media/call_with_kelly_benoit_bird.f1e40d6d.jpg";